import { Component, Inject, OnInit } from '@angular/core';
import { SupplierSelectionFormModel } from '../../../core/models/supplierDB/supplierSelectionForm.model';
import { SupplierContactFormModel } from '../../../core/models/supplierDB/supplierContactForm.model';
import { AppConstants } from '../../../app.constants';
import { NgFor, NgIf } from '@angular/common';
import { AccordionModule } from 'primeng/accordion';
import { L10N_LOCALE, L10nLocale, L10nTranslationModule } from 'angular-l10n';
import { SelectionTabComponent } from './components/selection-tab/selection-tab.component';

@Component({
	selector: 'supplierDB-registration-registration-overview',
	standalone: true,
	imports: [
		NgFor,
		AccordionModule,
		NgIf,
		L10nTranslationModule,
		SelectionTabComponent,
	],
	templateUrl: './registration-overview.component.html',
	styleUrl: './registration-overview.component.scss',
})
export class RegistrationOverviewComponent implements OnInit {
	public supplierContactData!: SupplierContactFormModel;
	public supplierSelectionData!: SupplierSelectionFormModel;

	public activeAccordionTabs: number[] = [];

	constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}

	ngOnInit(): void {
		this.supplierContactData = JSON.parse(
			localStorage.getItem(
				AppConstants.SDB_SUPPLIER_LOCAL_STORAGE_CONTACT
			)!
		);
		this.supplierSelectionData = JSON.parse(
			localStorage.getItem(
				AppConstants.SDB_SUPPLIER_LOCAL_STORAGE_SELECTION
			)!
		);
	}

	public getRegionNames(
		data: { name: string; code: string }[] | null
	): string[] | null {
		if (data === null) {
			return null;
		}
		return data.map((item) => item.name);
	}
}
